import React from 'react';

export default function HeroSection() {
  return (
    <section className="hero-section">
      <h1 className="hero-title">
        Análise de Segurança <span>Inteligente</span>
      </h1>
      <p className="hero-description">
        Verifique URLs suspeitas em tempo real, com reputação de domínio, padrões de phishing em múltiplas camadas.
      </p>
    </section>
  );
}
